import { s } from "../namespaces-BA-xInJF.mjs";
const attributeParser = s.attributeParser ?? {};
const { parseParameters } = s.attributeParser;
export {
  attributeParser,
  parseParameters
};
/*                                                */
